import React, { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Shared UI Library Components
import { CustomIcon, EIconName, InputReadOnly } from '@ppmcore/seven-ppm-core-shared-components-react';

// Styles
import './widget-block.scss';

// Store entities
import { openNotification } from '../../../../store/app-notifications/app-notifications.thunks';
import { getCompanyState } from '../../../../store/company/company.selectors';

type TWidgetBlockProps = {};

export const WidgetBlock: FC<TWidgetBlockProps> = (
  {}: TWidgetBlockProps
) => {

  const { company } = useSelector(getCompanyState);

  const dispatch = useDispatch<any>();

  const onCopyHandler = (): void => {
    dispatch(openNotification({
      type: 'success',
      description: 'Successfully copied!'
    }));
  }

  const onCopyErrorHandler = (): void => {
    dispatch(openNotification({
      type: 'error',
      description: 'Copy failed! Try again'
    }));
  }

  return (
    <div className="widget-block">
      <div className="widget-block--item">
        <div className="item-header">
          <CustomIcon name={ EIconName.Web_app }/> Web App
        </div>
        <div className="item-description">
          Share URL with your Clients and Consultants, to provide access to the system.
        </div>
        <div className="item-read">
          <InputReadOnly label={ 'URL' }
                         value={ `${ process.env.REACT_APP_USER_APP_URL }/${ company?.url_code }` }
                         isCopyIcon={ true }
                         textEllipsis={ true }
                         icon={ <CustomIcon name={ EIconName.ContentCopy }/> }
                         onCopy={ onCopyHandler }
                         onCopyError={ onCopyErrorHandler }
          />
        </div>
      </div>
      {/*<div className="widget-block--item">*/ }
      {/*  <div className="item-header">*/ }
      {/*   <CustomIcon name={ EIconName.Android_App } /> Mobile App*/ }
      {/*  </div>*/ }
      {/*  <div className="item-description">*/ }
      {/*    Share URL with your Clients and Counsellors, to find the mobile app on the App Store and Google Play Market.*/ }
      {/*  </div>*/ }
      {/*  <div className="item-read">*/ }
      {/*    <InputReadOnly label={ 'URL' }*/ }
      {/*                   value={ '' }*/ }
      {/*                   isCopyIcon={ true }*/ }
      {/*                   textEllipsis={ true }*/ }
      {/*                   icon={ <CustomIcon name={ EIconName.ContentCopy }/> }*/ }
      {/*                   onCopy={ onCopyHandler }*/ }
      {/*                   onCopyError={ onCopyErrorHandler }*/ }
      {/*    />*/ }
      {/*  </div>*/ }
      {/*</div>*/ }
      {/*<div className="widget-block--item">*/ }
      {/*  <div className="item-header">*/ }
      {/*   <CustomIcon name={ EIconName.Widget_app } /> Widget*/ }
      {/*  </div>*/ }
      {/*  <div className="item-description">*/ }
      {/*    Copy HTML code below to integrate Widget on your website.*/ }
      {/*  </div>*/ }
      {/*  <div className="item-read">*/ }
      {/*    <InputReadOnly label={ 'URL' }*/ }
      {/*                   value={ '' }*/ }
      {/*                   isCopyIcon={ true }*/ }
      {/*                   textEllipsis={ true }*/ }
      {/*                   icon={ <CustomIcon name={ EIconName.ContentCopy }/> }*/ }
      {/*                   onCopy={ onCopyHandler }*/ }
      {/*                   onCopyError={ onCopyErrorHandler }*/ }
      {/*    />*/ }
      {/*  </div>*/ }
      {/*</div>*/ }
    </div>
  );
}
